import { render } from "./NewOrderAuxiliar.vue?vue&type=template&id=20558ec3&scoped=true"
import script from "./NewOrderAuxiliar.vue?vue&type=script&lang=js"
export * from "./NewOrderAuxiliar.vue?vue&type=script&lang=js"

import "./NewOrderAuxiliar.vue?vue&type=style&index=0&id=20558ec3&lang=css"
import "./NewOrderAuxiliar.vue?vue&type=style&index=1&id=20558ec3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20558ec3"]])

export default __exports__